/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  max-width: 100%;
}
:host circle.rb_circle {
  height: 100%;
  width: 100%;
  fill: none;
  stroke: #8E989D;
  stroke: var(--davinci-color-outline, #8E989D);
  fill: #FFFFFF;
  fill: var(--davinci-color-background-input, #FFFFFF);
  stroke-width: 0.0714285714rem;
}
:host circle.rb_tick {
  height: 100%;
  width: 100%;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  visibility: hidden;
}
:host svg {
  height: 1.7142857143rem;
  width: 1.7142857143rem;
  vertical-align: middle;
}
:host .rb_label {
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  font-size: 1rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  padding-left: 0.5714285714rem;
  line-height: 1.7142857143rem;
}
:host .rb_label slot ::slotted(*) {
  line-height: 1.7142857143rem;
  font-size: 1rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .wrapper:focus {
  outline: none;
}
:host .wrapper:focus circle.rb_circle {
  fill: #e5f6ff;
  fill: var(--davinci-color-item-focus, #e5f6ff);
  stroke: #007CC1;
  stroke: var(--davinci-color-primary, #007CC1);
}

:host .wrapper {
  display: flex;
}
:host .wrapper svg {
  flex: 0 0 auto;
}
:host .wrapper .rb_label {
  flex: 1 1 auto;
}

:host(:hover) circle.rb_circle {
  stroke: #007CC1;
  stroke: var(--davinci-color-primary, #007CC1);
}

:host([checked]) circle.rb_tick {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  visibility: visible;
}
:host([checked]) circle.rb_circle {
  fill: none;
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) circle.rb_circle {
  stroke: #C5CACC;
  stroke: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) circle.rb_tick {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .rb_label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .rb_label slot ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
